import React from 'react';
import ArticleShell from '@/components/resources/ArticleShell';
import { ARTICLES, RESIDENTIAL_CLUSTER } from '@/data/resources/residentialCleanEnergy';

interface Props {
  articleKey: keyof typeof ARTICLES;
}

const ResidentialCleanEnergyArticle: React.FC<Props> = ({ articleKey }) => {
  const article = ARTICLES[articleKey];
  if (!article) return null;
  const { meta, Body } = article;
  return (
    <ArticleShell meta={meta} cluster={RESIDENTIAL_CLUSTER}>
      <Body />
    </ArticleShell>
  );
};

export default ResidentialCleanEnergyArticle;
